import React, { useEffect, useReducer } from 'react';

// STYLES
import styles from './Timer.scss';

// SUB MODULES
import TimerReelsSpins from './Timer.reelsSpins';

const Timer: React.FC<{}> = ({}) => {
    const [state, setState] = useReducer((state: {}, newState: {}) => ({ ...state, ...newState }), {});

    useEffect(() => {}, []);

    return (
        <div className={styles.timer_container}>
            <TimerReelsSpins />
        </div>
    );
};

export default Timer;
